import { atom } from "jotai";

import type {
  ArticleSearchAnswerModeEnum,
  hooksSearchResultStreamSubscription$data,
} from "scmp-app/queries/__generated__/hooksSearchResultStreamSubscription.graphql";

type AtomValue = {
  exploreKeyAngles: hooksSearchResultStreamSubscription$data[];
  followTheTimeline: hooksSearchResultStreamSubscription$data[];
  isReceivingExploreKeyAngles: boolean | undefined;
  isReceivingFollowTheTimeline: boolean | undefined;
  mode: ArticleSearchAnswerModeEnum | undefined;
};

export const searchResultStreamAtom = atom<AtomValue>({
  exploreKeyAngles: [],
  followTheTimeline: [],
  isReceivingExploreKeyAngles: undefined,
  isReceivingFollowTheTimeline: undefined,
  mode: undefined,
});
